import { render, staticRenderFns } from "./auditSettings.vue?vue&type=template&id=3024d689&scoped=true"
import script from "./auditSettings.vue?vue&type=script&lang=js"
export * from "./auditSettings.vue?vue&type=script&lang=js"
import style0 from "./auditSettings.vue?vue&type=style&index=0&id=3024d689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024d689",
  null
  
)

export default component.exports